import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import { loginByPhone } from "../api/user-center";
const queryParams = new URLSearchParams(window.location.search);
const channel = queryParams.get("channel") || "";

const routes = [
  {
    path: "/",
    name: "homeWithoutId",
    component: () => import("../views/Home.vue"),
    redirect: { name: "signup" },
    children: [
      {
        path: "signup",
        name: "signup",
        component: () => import("../views/Invite.vue"),
        meta: {
          title: "登录 | 逗逗 - 你的AI游戏伙伴",
          metaTags: [
            {
              name: "description",
              content:
                "登录试玩逗逗游戏伙伴：这是一款陪你一起玩游戏的AI桌宠软件，在这里有着各种个性的二次元人物，他们会在游戏过程中陪你聊天，还会讲笑话、唱歌等各种惊喜能力；他们懂游戏，更懂你",
            },
            {
              name: "keywords",
              content:
                "试玩逗逗游戏伙伴,逗逗游戏伙伴,试玩,注册逗逗,AI桌宠,PC桌宠,游戏陪玩,AI陪玩,逗逗,游戏伙伴,AI对话,大模型,AI唱歌,二次元人物,AI人物,桌宠,AI伙伴,AI助手,AI桌面",
            },
            {
              property: "og:title",
              content: "登录 | 逗逗 - 你的AI游戏伙伴",
            },
            {
              name: "og:description",
              content:
                "逗逗游戏伙伴是一款AI二次元桌宠软件，和为你定制的二次元AI人物一起快乐游戏",
            },
            {
              property: "og:img",
              content: "./icon/header.png",
            },
            {
              name: "og:image:alt",
              content: "和为你定制的AI二次元桌宠一起快乐游戏",
            },
          ],
        },
      },
      {
        path: "chat",
        name: "chat",
        component: () => import("../views/ChatPage.vue"),
        meta: {
          title: "对话 | 逗逗 - 你的AI游戏伙伴",
          metaTags: [
            {
              name: "description",
              content:
                "登录试玩逗逗游戏伙伴：这是一款陪你一起玩游戏的AI桌宠软件，在这里有着各种个性的二次元人物，他们会在游戏过程中陪你聊天，还会讲笑话、唱歌等各种惊喜能力；他们懂游戏，更懂你",
            },
            {
              name: "keywords",
              content:
                "试玩逗逗游戏伙伴,逗逗游戏伙伴,试玩,注册逗逗,AI桌宠,PC桌宠,游戏陪玩,AI陪玩,逗逗,游戏伙伴,AI对话,大模型,AI唱歌,二次元人物,AI人物,桌宠,AI伙伴,AI助手,AI桌面",
            },
            {
              property: "og:title",
              content: "对话 | 逗逗 - 你的AI游戏伙伴",
            },
            {
              name: "og:description",
              content:
                "逗逗游戏伙伴是一款AI二次元桌宠软件，和为你定制的二次元AI人物一起快乐游戏",
            },
            {
              property: "og:img",
              content: "./icon/header.png",
            },
            {
              name: "og:image:alt",
              content: "和为你定制的AI二次元桌宠一起快乐游戏",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/:id",
    name: "homeWithId",
    component: () => import("../views/Home.vue"),
    redirect: (to) => {
      // 这里可以添加额外的逻辑来决定是否重定向到signupWithId
      if (["sgai", "mutang", "tomato"].includes(to.params.id)) {
        return { name: "signupWithId", params: { id: to.params.id } };
      } else {
        return { name: "signup" };
      }
    },
    children: [
      {
        path: "signup",
        name: "signupWithId",
        component: () => import("../views/InviteWithIp.vue"),
        meta: {
          title: "登录 | 逗逗 - 你的AI游戏伙伴",
          metaTags: [
            {
              name: "description",
              content:
                "登录试玩逗逗游戏伙伴：这是一款陪你一起玩游戏的AI桌宠软件，在这里有着各种个性的二次元人物，他们会在游戏过程中陪你聊天，还会讲笑话、唱歌等各种惊喜能力；他们懂游戏，更懂你",
            },
            {
              name: "keywords",
              content:
                "试玩逗逗游戏伙伴,逗逗游戏伙伴,试玩,注册逗逗,AI桌宠,PC桌宠,游戏陪玩,AI陪玩,逗逗,游戏伙伴,AI对话,大模型,AI唱歌,二次元人物,AI人物,桌宠,AI伙伴,AI助手,AI桌面",
            },
            {
              property: "og:title",
              content: "登录 | 逗逗 - 你的AI游戏伙伴",
            },
            {
              name: "og:description",
              content:
                "逗逗游戏伙伴是一款AI二次元桌宠软件，和为你定制的二次元AI人物一起快乐游戏",
            },
            {
              property: "og:img",
              content: "./icon/header.png",
            },
            {
              name: "og:image:alt",
              content: "和为你定制的AI二次元桌宠一起快乐游戏",
            },
          ],
        },
      },
      {
        path: "chat",
        name: "chatWithId",
        component: () => import("../views/ChatPage.vue"),
        meta: {
          title: "对话 | 逗逗 - 你的AI游戏伙伴",
          metaTags: [
            {
              name: "description",
              content:
                "登录试玩逗逗游戏伙伴：这是一款陪你一起玩游戏的AI桌宠软件，在这里有着各种个性的二次元人物，他们会在游戏过程中陪你聊天，还会讲笑话、唱歌等各种惊喜能力；他们懂游戏，更懂你",
            },
            {
              name: "keywords",
              content:
                "试玩逗逗游戏伙伴,逗逗游戏伙伴,试玩,注册逗逗,AI桌宠,PC桌宠,游戏陪玩,AI陪玩,逗逗,游戏伙伴,AI对话,大模型,AI唱歌,二次元人物,AI人物,桌宠,AI伙伴,AI助手,AI桌面",
            },
            {
              property: "og:title",
              content: "对话 | 逗逗 - 你的AI游戏伙伴",
            },
            {
              name: "og:description",
              content:
                "逗逗游戏伙伴是一款AI二次元桌宠软件，和为你定制的二次元AI人物一起快乐游戏",
            },
            {
              property: "og:img",
              content: "./icon/header.png",
            },
            {
              name: "og:image:alt",
              content: "和为你定制的AI二次元桌宠一起快乐游戏",
            },
          ],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // 更新文档标题
  to.matched
    .slice()
    .reverse()
    .forEach((matched) => {
      if (matched.meta.title) {
        document.title = matched.meta.title;
      }
    });

  // 移除旧的 meta 标签
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // 检查当前路由是否有 meta 标签
  if (!to.meta.metaTags) return next();

  // 创建新的 meta 标签
  // to.meta.metaTags
  //   .map((tagDef) => {
  //     const tag = document.createElement("meta");

  //     Object.keys(tagDef).forEach((key) => {
  //       const value = tagDef[key];
  //       tag.setAttribute(key === "property" ? key : "name", value);
  //       tag.setAttribute("content", tagDef["content"]);
  //     });

  //     // 追踪 Vue Router 创建的 meta 标签
  //     tag.setAttribute("data-vue-router-controlled", "");

  //     return tag;
  //   })
  //   // 将 meta 标签添加到 head 中
  //   .forEach((tag) => document.head.appendChild(tag));
  llll(to)
  next();
});

function detectDeviceType(){
  const ua = navigator.userAgent;
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 800 && window.innerHeight <= 600;

  if (isMobile || isTouchDevice || isSmallScreen) {
    return "Mobile";
  } else {
    return "Desktop";
  }
};


function llll(to){
  console.log(to.params.id);
  if (detectDeviceType() === "Mobile") {
    window.location.href = process.env.VUE_APP_DEV_CN_MOBILE_URL+'mobile/'+to.params.id+`?channel=${channel}`;
    // console.log(to.params.id,'1234');
}
}
export default router;
